var initializeFullPageLoader;
document.getElementById('page-loader').style.display = 'block';

(function($) {

    initializeFullPageLoader = function() {

        var preventUnload = false;

        // Prevent loader to show when mailto link is clicked
        $(document).on('click', 'a[href^="mailto:"], a[href^="javascript:linkTo_UnCryptMailto"]', function(e) {
            preventUnload = true;
        });

        // Show loader on page change
        $(window).on('beforeunload', function(e) {
            if(!preventUnload) {
                $('#page-loader').fadeIn(500);
            } else {
                preventUnload = false;
            }
        });

        // FadeOut loader on page load
        $('#page-loader').fadeOut(500);

        window.onpageshow = function() {
            $('#page-loader').fadeOut(500);
        };

    };

})(jQuery);